module.exports = __webpack_public_path__ + "static/img/welcome.42f9d40.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/login/welcome.png
// module id = q8d1
// module chunks = 86